import type { FC, SVGProps } from 'react';

const PeakFlowMeterIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_17340_3000)">
      <path
        d="M8.7218 21.6872L8.05382 10.8187C8.02464 10.344 8.40173 9.94304 8.87728 9.94304H15.3357C15.8113 9.94304 16.1885 10.3442 16.1591 10.819L15.4866 21.6882C15.4062 22.9874 14.329 24 13.0273 24H11.1811C9.87902 24 8.80168 22.9868 8.7218 21.6872Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.06773"
      />
      <path
        d="M9.64258 17.4307H13.7492"
        stroke="white"
        strokeWidth="0.821331"
      />
      <path
        d="M9.64258 20.7168H12.1512"
        stroke="white"
        strokeWidth="0.821331"
      />
      <path
        d="M9.64258 19.0732H11.2852H12.9279"
        stroke="white"
        strokeWidth="0.821331"
      />
      <path
        d="M9.64258 15.7881H14.5706"
        stroke="white"
        strokeWidth="0.821331"
      />
      <path
        d="M11.1613 11.6807V13.8358H10.9057V12.2522C10.9057 12.2311 10.9062 12.2085 10.9072 12.1845C10.9092 12.1604 10.9112 12.1359 10.9132 12.1108L10.1732 13.4583C10.1502 13.5034 10.1151 13.526 10.068 13.526H10.0258C9.97872 13.526 9.94363 13.5034 9.92057 13.4583L9.16559 12.1048C9.17161 12.1579 9.17462 12.207 9.17462 12.2522V13.8358H8.91895V11.6807H9.13401C9.16008 11.6807 9.18013 11.6832 9.19417 11.6882C9.2082 11.6932 9.22174 11.7072 9.23477 11.7303L9.97922 13.0568C9.99126 13.0808 10.0028 13.1059 10.0138 13.132C10.0258 13.158 10.0369 13.1846 10.0469 13.2117C10.0569 13.1846 10.0675 13.158 10.0785 13.132C10.0895 13.1049 10.1015 13.0793 10.1146 13.0553L10.8455 11.7303C10.8575 11.7072 10.8706 11.6932 10.8846 11.6882C10.8996 11.6832 10.9202 11.6807 10.9463 11.6807H11.1613Z"
        fill="white"
      />
      <path
        d="M12.8569 13.0357L12.5185 12.1589C12.5085 12.1328 12.498 12.1028 12.4869 12.0687C12.4759 12.0336 12.4654 11.9965 12.4553 11.9574C12.4343 12.0386 12.4127 12.1063 12.3907 12.1604L12.0523 13.0357H12.8569ZM13.4645 13.8358H13.2389C13.2128 13.8358 13.1918 13.8293 13.1757 13.8163C13.1597 13.8032 13.1477 13.7867 13.1396 13.7666L12.9381 13.2463H11.9711L11.7696 13.7666C11.7635 13.7847 11.752 13.8007 11.735 13.8148C11.7179 13.8288 11.6969 13.8358 11.6718 13.8358H11.4462L12.308 11.6807H12.6027L13.4645 13.8358Z"
        fill="white"
      />
      <path
        d="M15.3918 13.8358H15.1031C15.081 13.8358 15.0635 13.8303 15.0504 13.8193C15.0384 13.8072 15.0284 13.7942 15.0203 13.7802L14.4428 12.8748C14.4348 12.8989 14.4258 12.9194 14.4158 12.9365L13.8533 13.7802C13.8433 13.7942 13.8322 13.8072 13.8202 13.8193C13.8092 13.8303 13.7936 13.8358 13.7736 13.8358H13.5029L14.2443 12.7289L13.5329 11.6807H13.8232C13.8443 11.6807 13.8598 11.6842 13.8698 11.6912C13.8799 11.6982 13.8889 11.7082 13.8969 11.7213L14.4594 12.5845C14.4664 12.5635 14.4769 12.5404 14.491 12.5154L15.0218 11.7273C15.0299 11.7132 15.0394 11.7022 15.0504 11.6942C15.0615 11.6852 15.0745 11.6807 15.0895 11.6807H15.3678L14.6534 12.7154L15.3918 13.8358Z"
        fill="white"
      />
      <path
        d="M12.2364 8.97656H12.1008C9.89802 8.97656 8.1123 7.19084 8.1123 4.98805C8.1123 2.78526 9.89802 0.99954 12.1008 0.99954H12.2364C14.4392 0.99954 16.2249 2.78526 16.2249 4.98805C16.2249 7.19084 14.4392 8.97656 12.2364 8.97656Z"
        stroke="currentColor"
        strokeWidth="1.06773"
      />
      <path
        d="M12.1064 2.6442L9.73547 6.75085L14.4774 6.75085L12.1064 2.6442ZM12.5171 9.21484L12.5171 6.34019L11.6958 6.34019L11.6958 9.21484L12.5171 9.21484Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_17340_3000">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default PeakFlowMeterIcon;
